export default {
  mounted() {
    console.log('copy-html mounted')
    const findAndAttachListener = () => {
      console.log('finding copy button')
      const copyButton = document.getElementById(this.el.dataset.copyButton)
      if (!copyButton) {
        // Retry after a short delay if button not found
        setTimeout(findAndAttachListener, 2000)
        return
      }

      const richText = this.el
      const successMessage = richText.dataset.successMessage ?? 'Copied!'
      const notifySuccess = () => this.pushEvent('trigger_flash', { type: 'success', message: successMessage })

      copyButton.addEventListener('click', async function () {
        try {
          console.log('copying text')
          const html = new Blob([richText.innerHTML], { type: 'text/html' })
          const text = new Blob([richText.innerText.trim()], { type: "text/plain" });
          await navigator.clipboard.write([new ClipboardItem({ 'text/html': html, 'text/plain': text })])
          notifySuccess()
        } catch (err) {
          console.error('Unable to copy rich text:', err)
        }
      })
    }

    // Start the initial attempt to find and attach the listener
    findAndAttachListener()
  },
}
